export enum PageType {
  AaaApplication = "AaaApplication",
  Landing = "Landing",
  ProgramSelection = "ProgramSelection",
  IdXboxApplication = "IdXboxApplication",
  IdAzureApplication = "IdAzureApplication",
  PitchApplication = "PitchApplication",
  Error = "Error",
}
